
var chartTypes = {
	'CHECKBOX':  'bar',
	'RADIO':     'pie',
	'DROP_DOWN': 'pie',
};

export default class SurveyStatsController {

	constructor (
        $state,
        survey,
        stats,
        selectedStore,
		endDate,
		startDate,
        stores
    ) {
		this.$state = $state;
		this.survey = survey;
		this.stores = stores;
		this.endDate = endDate;
		this.startDate = startDate;
		this.selectedStore = selectedStore;
		var count = 0;
		var childCount = 0;
		this.statsInSurvey = survey.elements.map((question, index) => {
			if (question.isChild) {
				childCount++;
			} else {
				childCount = 0;
				count++;
			}
			return formatStats(
				question,
				stats.filter(stat => stat.questionId === question.id)[0] || {},
				question.isChild ? count+'.'+childCount : count,
			);
		});
		this.statsNotInSurvey = (survey && survey.elements) ? stats
			.filter(stat => survey.elements.filter(question => stat.questionId === question.id).length === 0)
			.map(stat => formatStats(null, stat)) : [];
	}

	back () {
		this.$state.go('surveysPage');
	}

	openReceipt (receiptUrl) {
		swal({
			title: '',
			text: '<iframe'
			     +'	style="display: block; border: 0; width: 100%; height: 60vh;"'
			     +'	src="https://web.mangooid.com/pdf-viewer.html?link='+encodeURIComponent(receiptUrl)+'"'
			     +'></iframe>',
			html: true,
		});
	}

	getStatClass (stat) {
		return stat.isChild ? 'survey-stats-page__stat--child' : '';
	}

}

SurveyStatsController.$inject = [
    '$state',
    'survey',
    'stats',
    'selectedStore',
	'endDate',
	'startDate',
    'stores'
];


/*
 * Helpers
 */
const isMultipleChoice = stat => !!chartTypes[stat.type];

const isStarRating = stat => stat.type === 'STAR_RATING';

const isFreeText = stat => !isMultipleChoice(stat) && !isStarRating(stat);

const getData = (stat, total) => {
	switch (chartTypes[stat.type]) {
		case 'bar':
			return [(stat.answers || []).map(s => Math.round(100*s.count/total))];
		case 'pie':
			return (stat.answers || []).map(s => s.count);
		default:
			return null;
	}
};

const getLabels = (stat, total) => {
	switch (chartTypes[stat.type]) {
		case 'bar':
		case 'pie':
			return (stat.answers || []).map(s => s.answer+' ('+Math.round(100*s.count/total)+'%)');
		default:
			return null;
	}
};

const getSeries = stat => {
	switch (chartTypes[stat.type]) {
		case 'bar':
			return [stat.question];
		default:
			return null;
	}
};

const getTotal = stat => {
	if (chartTypes[stat.type] || stat.type === 'STAR_RATING') {
		return (stat.type === 'CHECKBOX') ? stat.responders : (stat.answers || []).reduce((t, s) => t + s.count, 0);
	}
	return (stat.answers || []).length;
};

const getAverageRating = stat => {
	if (stat && stat.answers && stat.answers.length) {
		// ignore no rating star
		const answers = stat.answers.filter(a => a.answer != '' && a.answer != '0');
		const total = answers.reduce((r, a) => r + parseInt(a.answer) * a.count, 0);
		const nbVote = answers.reduce((r, a) => r + a.count, 0);
		return total / nbVote;
	}
	return 0;
};

const formatStats = (question, stat, index) => {
	const total = getTotal(stat);
	const options = (chartTypes[question ? question.type : stat.type] === 'bar') ? {
		scaleBeginAtZero: true,
		scaleOverride : true,
		scaleSteps : 2,
		scaleStepWidth : 50,
		scaleStartValue : 0
	} : {
		scales: {
			xAxes: [{
				display: false,
				angleLines: {
					display: false
				},
				gridLines : {
					display : false,
					drawBorder: false
				},
				ticks: {
					beginAtZero:true,
					scaleShowLabels: false
				}
			}],
			yAxes: [{
				display: false,
				angleLines: {
					display: false
				},
				gridLines : {
					display : false,
					drawBorder: false
				},
				ticks: {
					beginAtZero:true,
					scaleShowLabels: false
				}
			}]
		}
	};

	return {
		question:         (index ? index+'. ' : '')+(question ? question.text : stat.question),
		isMultipleChoice: isMultipleChoice(question || stat),
		isStarRating:     isStarRating(question || stat),
		isChild:          question && question.isChild,
		isFreeText:       isFreeText(question || stat),
		type:             question ? question.type : stat.type,
		answers:          stat && stat.answers || [],
		chartType:        chartTypes[question ? question.type : stat.type],
		total:            total,
		data:             getData(stat, total),
		labels:           getLabels(stat, total),
		series:           getSeries(stat),
		averageRating:    getAverageRating(stat),
		options
	};
};



// WEBPACK FOOTER //
// ./src/page/surveyStats/surveyStats.controller.js